<template>
  <div class="modal-backdrop">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Напишите отзыв о покупке</h5>
        <button type="button" class="btn-close" @click="closeModal">x</button>
      </div>
      <div class="modal-body">
        <div class="rating mb-2">
          <span class="stars me-2" :class="{ select: selectRating >= 1 }" @click="selectRating = 1">★</span>
          <span class="stars me-2" :class="{ select: selectRating >= 2 }" @click="selectRating = 2">★</span
          ><span class="stars me-2" :class="{ select: selectRating >= 3 }" @click="selectRating = 3">★</span
          ><span class="stars me-2" :class="{ select: selectRating >= 4 }" @click="selectRating = 4">★</span
          ><span class="stars me-2" :class="{ select: selectRating >= 5 }" @click="selectRating = 5">★</span>
        </div>
        <textarea
          v-model="comment"
          class="form-control"
          rows="5"
          placeholder="Комментарий к отзыву"
          required
        ></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" :disabled="!comment || comment === null" @click="sendComment">
          Отправить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref } from 'vue';
  import MarketplaceService from '@/services/marketplace';
  import { useRoute, useRouter } from 'vue-router';

  export default defineComponent({
    name: 'ReviewModal',
    props: {
      id: String,
    },
    emits: ['close'],
    setup(_props, { emit }) {
      const selectRating = ref(0);
      const parentComment = ref(null);
      const comment = ref(null);
      const closeModal = async () => {
        emit('close');
      };

      const sendComment = () => {
        if (selectRating.value !== 0 && comment.value !== '') {
          MarketplaceService.sendComment(selectRating.value, comment.value, props.id, parentComment.value);
          closeModal();
        }
      };
      return {
        closeModal,
        sendComment,
        comment,
        selectRating,
      };
    },
  });
</script>

<style scoped lang="scss">
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    background-color: rgb(0 0 0 / 50%);
  }

  .modal-content {
    width: 400px;
    padding: 20px;

    background-color: white;
    border-radius: 8px;
  }

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .btn-close {
    font-size: 1.5rem;
    line-height: 1;

    background: transparent;
    border: none;
    cursor: pointer;
  }

  textarea.form-control {
    width: 100%;
    margin-bottom: 20px;
  }
</style>
